import { Button } from "reactstrap";
import PageLayout from "../../../components/layout/page";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import { AddUpdateMediaType } from "./addUpdate";
import { plus } from "../../../constant/icons";
import { useEffect } from "react";
import { DataView } from "../../../components/table/table";
import { columns } from "./columns";
import { useApi } from "../../../helper/apiHook";
import ModalView from "../../../components/modal";
export const MediaTypeApi = (paging?:boolean, dataLoad: any = {}) => {
  return { ...useApi("/media-types",paging, undefined, dataLoad) };
};

export default function MediaType() {
  const api = MediaTypeApi(true);
  useEffect(() => {
    api.mutate();
  }, []);
  const AddUpdate = useAddUpdate();
  return (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                name: "",
                description: "",
                type:""
                // image: []
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <DataView
            columns={columns({
              api,
              openAddEditFrom: AddUpdate.openAddEditFrom,
            })}
            rows={api.data}
            updatePagination={api.updatePagination}
            currentPage={api.currentPage}
            rowCount={api.rowCount}
            limit={api.limit}
          />
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={AddUpdate.currentValue?.id ? "Edit Media Type" : "Add Media Type"
          }
          onModalDismiss={AddUpdate.closeAddEditFrom}
        >
          <AddUpdateMediaType
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}
